import { jsx as _jsx } from "react/jsx-runtime";
import { Helmet } from 'react-helmet-async';
export default function GoogleTagManager() {
    return (_jsx(Helmet, { children: _jsx("script", { children: `
				(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer','GTM-NSRDJJC');
			` }) }));
}
//# sourceMappingURL=GoogleTagManager.js.map